export const BAND_MEMBERSHIP_STATUS_ACTIVE = "ACTIVE";
export const BAND_MEMBERSHIP_STATUS_PENDING = "PENDING";

export const normalizeBandMembershipStatus = (value) => (
    String(value || "").trim().toUpperCase()
);

export const isActiveBandMembershipStatus = (value, options = {}) => {
    const status = normalizeBandMembershipStatus(value);
    return status === BAND_MEMBERSHIP_STATUS_ACTIVE || (options.treatMissingAsActive === true && !status);
};

export const isPendingBandMembershipStatus = (value) => (
    normalizeBandMembershipStatus(value) === BAND_MEMBERSHIP_STATUS_PENDING
);

export const getBandMemberMembershipStatus = (member) => (
    normalizeBandMembershipStatus(member?.membershipStatus || member?.status)
);

export const isActiveBandMemberEntry = (member, options = {}) => (
    Boolean(member)
    && !member?.leftAt
    && isActiveBandMembershipStatus(
        member?.membershipStatus || member?.status,
        options,
    )
);
